'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialAppleOutline = function IoSocialAppleOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.1 13.3c-1.2 0-2 0.3-2.9 0.6-0.8 0.3-1.6 0.6-2.7 0.6s-2-0.3-2.9-0.6c-0.9-0.3-1.7-0.6-2.7-0.6-0.8 0-1.8 0.2-2.6 0.8-1 0.5-1.8 1.4-2.5 2.4-0.9 1.4-1.2 3.7-1 6 0.3 2.7 1.3 5.4 2.8 7.7 1 1.7 2.3 3.6 3.9 3.6h0c0.7 0 1.1-0.3 1.6-0.5 0.8-0.4 1.8-0.8 3.4-0.8 1.7 0 2.7 0.4 3.5 0.8 0.5 0.2 0.9 0.5 1.5 0.5 1.7 0 3.4-2.8 4-3.8 0.7-0.9 1-1.6 1.4-2.4-1-0.6-1.8-1.3-2.4-2.2-0.8-1.2-1.3-2.6-1.4-4.1-0.1-1.4 0.2-2.9 0.8-4.1 0.5-1 1.1-1.7 1.9-2.4-1.1-1-2.5-1.5-3.7-1.5z m0-1.3c1.9 0 4.1 1.1 5.5 3.1-4.9 2.8-4.1 10 0.9 11.9-0.7 1.6-1 2.2-1.9 3.6-1.2 2-2.9 4.4-5.1 4.4h0c-1.9 0-2.5-1.2-5-1.2-2.5 0-3.1 1.2-5 1.2h0c-2.2 0-3.8-2.2-5-4.1-3.5-5.4-3.8-11.8-1.7-15.1 1.5-2.4 3.9-3.8 6.1-3.8 2.3 0 3.7 1.3 5.6 1.3 1.8 0 2.9-1.3 5.6-1.3z m-1.9-5.4c-0.8 0.4-1.6 1-2.2 1.7-0.3 0.4-0.7 1-1 1.8-0.1 0.2-0.1 0.4-0.1 0.7 0.8-0.3 1.6-0.9 2.1-1.7 0.4-0.3 1-1.4 1.2-2.5z m1.3-1.6c0.2 1.8-0.5 3.6-1.4 4.8-1.1 1.4-2.8 2.4-4.4 2.4h-0.1c-0.3-1.7 0.5-3.4 1.4-4.7 1.1-1.3 2.9-2.4 4.5-2.5z' })
        )
    );
};

exports.default = IoSocialAppleOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-apple-outline.js
// module id = 2417
// module chunks = 0